function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 14.5a3 3 0 0 1-2.943-3.594A3.072 3.072 0 0 1 7.111 8.5H14a.5.5 0 0 0 .5-.5V1.5a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v21a1 1 0 0 0 1 1h12.5a1 1 0 0 0 1-1V15a.5.5 0 0 0-.5-.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.625 10.719l-1.159-.926-1.343-1.075-2.5-2A1 1 0 0 0 17 7.5V10H7a1.5 1.5 0 0 0 0 3h10v2.5a1 1 0 0 0 1.625.781l2.5-2 1.343-1.074 1.159-.927a1 1 0 0 0 0-1.562z"
});

var SvgLogout1Bold = function SvgLogout1Bold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default SvgLogout1Bold;